import { getAccountPaymentMethods } from '@cocoonspace/sdk-js/domains/account/account'
import { useQuery } from '@tanstack/react-query'

export const getWallet = () => {
	return getAccountPaymentMethods().then((res) => {
		const pm = res.data.find((pm) => pm.type === 'wallet')

		if (!pm) return null

		return {
			amount: pm.wallet?.amount || 0,
			expiredAt: pm.wallet?.expires,
			id: pm.id,
		}
	})
}

export const useWallet = ({ enabled = true }: { enabled?: boolean } = {}) => {
	return useQuery({
		queryKey: ['wallet'],
		queryFn: getWallet,
		staleTime: 1000 * 60 * 5,
		enabled,
	})
}
